import { useEffect } from "react";
import { React, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { t } from "../../Helper";
import { useSelector } from "react-redux";

const BasicBusinessInfo = ({ onChange, getContactNumber }) => {
  const [yourBusinessName, setYourBusinessName] = useState(
    "Your Business / Organization Name"
  );
  const [contactPersonName, setContactPersonName] = useState(
    "Contact Person Name"
  );
  const [businessEmail, setBusinessEmail] = useState("Business Email Id");
  const [businessContactNumber, setBusinessContactNumber] = useState(
    "Business Contact Number"
  );

  const [contactNumber, setContactNumber] = useState();
  const [basicBusinessInfo, setBasicBusinessInfo] = useState({});

  const { preferredLanguage, currentLanguage } = useSelector(
    (state) => state.settings
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    setBasicBusinessInfo((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      onChange(updated);
      return updated;
    });
  };

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await t(
          yourBusinessName,
          currentLanguage,
          preferredLanguage
        );
        setYourBusinessName(fetchedData);

        const fetchedData2 = await t(
          contactPersonName,
          currentLanguage,
          preferredLanguage
        );
        setContactPersonName(fetchedData2);

        const fetchedData3 = await t(
          businessEmail,
          currentLanguage,
          preferredLanguage
        );
        setBusinessEmail(fetchedData3);

        const fetchedData4 = await t(
          businessContactNumber,
          currentLanguage,
          preferredLanguage
        );
        setBusinessContactNumber(fetchedData4);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [preferredLanguage]);

  useEffect(() => {
    getContactNumber(contactNumber);
  }, [contactNumber]);

  return (
    <>
      <div className="col-12 col-md-6">
        <label className="form-label section-title">{yourBusinessName}</label>
        <input
          type="text"
          id="businessName"
          name="businessName"
          onChange={handleChange}
          className="form-control"
          required
        />
      </div>

      <div className="col-12 col-md-6">
        <label className="form-label section-title">{contactPersonName}</label>
        <input
          type="text"
          id="contactPersonName"
          name="contactPersonName"
          onChange={handleChange}
          className="form-control"
          required
        />
      </div>

      <div className="col-12 col-md-6">
        <label className="form-label section-title">{businessEmail}</label>
        <input
          type="email"
          className="form-control"
          id="businessEmail"
          name="businessEmail"
          required
          onChange={handleChange}
        />
      </div>

      <div className="col-12 col-md-6">
        <label className="form-label section-title">{businessContactNumber}</label>
        <PhoneInput
          className="number"
          country={"us"}
          required
          name="businessContactNumber"
          value={contactNumber}
          onChange={setContactNumber}
        />
      </div>
    </>
  );
};

export default BasicBusinessInfo;
